// src/types/housekeeping/HousekeepingStatus.ts
var HousekeepingStatus = /* @__PURE__ */ ((HousekeepingStatus2) => {
  HousekeepingStatus2["Dirty"] = "dirty";
  HousekeepingStatus2["Clean"] = "clean";
  HousekeepingStatus2["Inspected"] = "inspected";
  return HousekeepingStatus2;
})(HousekeepingStatus || {});
var HousekeepingStatusSource = /* @__PURE__ */ ((HousekeepingStatusSource2) => {
  HousekeepingStatusSource2["Manual"] = "manual";
  HousekeepingStatusSource2["Checkout"] = "checkout";
  HousekeepingStatusSource2["VacantSweep"] = "vacant_sweep";
  HousekeepingStatusSource2["OutOfOrderEnded"] = "out_of_order_ended";
  return HousekeepingStatusSource2;
})(HousekeepingStatusSource || {});

export {
  HousekeepingStatus,
  HousekeepingStatusSource
};
